import { createAuthClient } from 'better-auth/react'

/**
 * Client d'authentification.
 *
 * `baseURL` n'est pas renseigné : le client tape la même origine que la page,
 * ce qui est toujours vrai ici (le serveur sert le build). Le figer
 * obligerait à distinguer dev et production pour rien.
 */
export const authClient = createAuthClient()

export const { useSession, signIn, signOut, signUp } = authClient
